document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    const autoformat = body.dataset.autoformat;
    const isHomePage = body.classList.contains("homepage");

    if (autoformat === "Accordion" && !isHomePage) {
        let headerTag = "main h2";
        let headers = document.querySelectorAll(headerTag);

        if (headers.length === 0) {
            console.log("h2 headers.length === 0");
            headerTag = "main h3";
            headers = document.querySelectorAll(headerTag);
        }

        console.log("headers.length", headers.length);

        if (headers.length > 1) {
            const firstHeader = headers[0];
            const parent = firstHeader.parentElement;

            if (autoformat === "Accordion") {
                parent.classList.add("accordion");
                parent.id = "accordion";
            }

            let ul = document.createElement("ul");
            if (autoformat === "Links") {
                const anchorList = document.querySelector("#AnchorList"); // Assuming AnchorList is an ID
                if (anchorList) anchorList.appendChild(ul);
            }

            headers.forEach((header, index) => {
                const i = index + 1;
                const html = header.innerHTML;

                if (autoformat === "Links") {
                    let text = header.textContent;
                    if (text && text !== "" && text !== "\xa0") {
                        const safeText = text.replace(/"/g, "&quot;");
                        header.insertAdjacentHTML('afterbegin', `<a name="${safeText}"></a>`);
                        ul.insertAdjacentHTML('beforeend', `<li><a href="#${safeText}">${safeText}</a></li>`);
                    }
                }

                if (autoformat === "Accordion") {
                    // Helper to replicate nextUntil
                    let htmlBetween = [];
                    let next = header.nextElementSibling;
                    while (next && !next.matches(headerTag)) {
                        htmlBetween.push(next);
                        next = next.nextElementSibling;
                    }

                    let divFound = false;
                    let betweenHTML = "";
                    htmlBetween.forEach((el) => {
                        if (el.tagName === "DIV") divFound = true;
                        if (!divFound) {
                            betweenHTML += el.outerHTML;
                            el.style.display = "none";
                        }
                    });

                    // Build Accordion Card
                    const card = document.createElement("div");
                    card.className = "accordion-item";

                    const hTag = headerTag.split(" ")[1]; // Gets 'h2' or 'h3'
                    const heading = `<${hTag}>${html}</${hTag}>`;

                    card.innerHTML = `
                        <div class="accordion-header">
                            <button class="accordion-button collapsed" type="button" aria-expanded="false"
                                    data-bs-toggle="collapse" data-bs-target="#collapse${i}">
                                ${html}
                            </button>
                        </div>
                        <div id="collapse${i}" class="accordion-collapse collapse" data-bs-parent="#accordion">
                            <div class="card-body">
                                ${heading}${betweenHTML}
                            </div>
                        </div>`;

                    // card.querySelector("button").addEventListener("click", (e) => {
                    //     console.log(e)
                    //     // store state of button (collapsed/not collapsed)
                    //     // collapse all
                    //     //if (button is collapsed) then uncollapse else collapse 

                    //     const collapsed = e.target.getAttribute("aria-expanded") == "false"
                    //     const btnTarget = e.target.closest(".accordion-item").querySelector(".accordion-collapse")
                    //     e.target.closest(".accordion").querySelectorAll(".accordion-item").forEach((p) => {
                    //         p.querySelector(".accordion-button").setAttribute("aria-expanded", "false")
                    //         p.querySelector(".accordion-button").classList.add("collapsed")
                    //         p.querySelector(".accordion-collapse").classList.remove("show")
                    //     })
                    //     if (collapsed) {
                    //         e.target.setAttribute("aria-expanded", true)
                    //         e.target.classList.remove("collapsed")
                    //         btnTarget.classList.add("show")
                    //     }
                    // })

                    header.style.display = "none";

                    if (html.replace(/&nbsp;/g, "").trim() !== "") {
                        header.insertAdjacentElement('afterend', card);
                    }
                }
            });
        }
    }
});